{
  "CSAT": {
    "TITLE": "Bewerten Sie Ihre Konversation",
    "PLACEHOLDER": "Erzählen Sie uns mehr...",
    "RATINGS": {
      "POOR": "😞 Poor",
      "FAIR": "😑 Fair",
      "AVERAGE": "😐 Average",
      "GOOD": "😀 Good",
      "EXCELLENT": "😍 Excellent"
    }
  }
}
